import { RECEIVE_DISCOUNTS, REQUEST_DISCOUNTS } from '../actions'

export default (
    state = {
        fetchSuccessful: null,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_DISCOUNTS:
            return { ...state, shouldFetch: false }

        case RECEIVE_DISCOUNTS:
            return { ...state, ...data }

        default:
            return state
    }
}
